<template>
    <div>
        <Header title="签约心理师" memo="管理签约心理师信息"></Header>
        <a-divider />
        <div class="flex-x-space-between" :style="{ marginTop: '16px' }">
            <div>
                <a-button type="primary" icon="link" @click="showSignForm" :style="{ marginRight: '8px' }">
                    添加签约
                </a-button>
            </div>
            <div>
                <a-form-model layout="inline" :model="query">
                    <a-form-model-item>
                        <a-input v-model="query.name" placeholder="心理师昵称" @pressEnter="execQuery">
                            <a-icon slot="prefix" type="user" style="color:rgba(0,0,0,.25)" />
                        </a-input>
                    </a-form-model-item>
                    <a-form-model-item>
                        <a-button icon="search" @click="execQuery">
                            查询
                        </a-button>
                    </a-form-model-item>
                    <a-form-model-item>
                        <a-button icon="retweet" @click="execReload">
                            刷新
                        </a-button>
                    </a-form-model-item>
                </a-form-model>
            </div>
        </div>
        <a-divider />
        <a-table :style="{ marginTop: '16px' }" :row-key="record => record.id" :data-source="datas" :loading="loading" :row-selection="{ type: 'checkbox', onChange: onSelectChange }" bordered :pagination="false">
            <a-table-column key="info" ellipsis>
                <span slot="title">心理师信息</span>
                <template slot-scope="text, record">
                    <span>
                        <a-tag color="#2db7f5">
                            {{ record.id }}
                        </a-tag>
                        {{ record.name }}
                    </span>
                </template>
            </a-table-column>
            <a-table-column key="action" fixed width="200px">
                <span slot="title">操作</span>
                <template slot-scope="text, record">
                    <a-button type="link" icon="eye" @click="showView(record)">
                        详情
                    </a-button>
                    <a-button type="link" icon="disconnect" @click="execUnsign(record)">
                        解约
                    </a-button>
                </template>
            </a-table-column>
        </a-table>

        <a-pagination
            :style="{ marginTop: '15px' }"
            :total="pager.rows"
            :current="query.page"
            :show-total="total => `共计 ${total} 条数据`"
            show-quick-jumper
            show-less-items
            show-size-changer
            hide-on-single-page
            :page-size.sync="query.size"
            :page-size-options="['10', '25', '50', '100']"
            @change="onChangePage"
            @showSizeChange="onChangeSize"
        />

        <ViewComp title="心理师详情" :item="now" :show.sync="view" v-if="view"></ViewComp>

        <SignComp :show.sync="sign" v-if="sign" @doLoad="doLoad"></SignComp>
    </div>
</template>

<script>
import ViewComp from './ViewComp'
import SignComp from './SignComp'

export default {
    name: 'UnitCta',
    components: {
        ViewComp,
        SignComp
    },
    computed: {
        loading() {
            return this.$store.state.Loading.flag && !this.$store.state.Loading.full
        },
        rowSelection() {
            return {
                onChange: this.onSelectRows
            }
        }
    },
    data() {
        return {
            query: {
                page: 1,
                size: 10,
                time: 0,
                name: ''
            },
            selRows: [],
            datas: [],
            pager: {
                rows: 0,
                pnum: 1,
                pnow: 1,
                time: 0
            },
            view: false,
            now: {},
            sign: false
        }
    },
    mounted() {
        this.$store.commit('setBreadcrumb', ['机构信息', '签约心理师'])
        this.doLoad()
    },
    methods: {
        doLoad() {
            this.$http
                .get('/ums/unit/cta/list', {
                    params: this.query,
                    loading: {
                        full: false
                    }
                })
                .then(result => {
                    if (result.data.pnow === 1) {
                        this.query.time = result.data.time
                    }
                    this.pager = result.data
                    this.datas = result.datas
                })
        },
        doUnsign(id) {
            this.$http
                .post('/ums/unit/cta/unsign', {
                    rid: id
                })
                .then(result => {
                    if (result.code === 0) {
                        this.$message.success('解约成功')
                        this.doLoad()
                    }
                })
        },
        onSelectChange(selectedRowKeys, selectedRows) {
            this.selRows = selectedRows
        },
        onChangePage(page) {
            this.query.page = page
            this.doLoad()
        },
        onChangeSize(page, size) {
            this.query.size = size
            this.query.page = 1
            this.doLoad()
        },
        execQuery() {
            this.query.page = 1
            this.doLoad()
        },
        execReload() {
            this.query = {
                page: 1,
                size: 10,
                time: 0,
                name: ''
            }
            this.doLoad()
        },
        execUnsign(item) {
            this.$confirm({
                title: '是否解除心理师[' + item.name + ']的签约关系',
                content: '编号：[' + item.id + ']',
                okText: '确认解约',
                okType: 'danger',
                cancelText: '取消',
                onOk: () => {
                    this.doUnsign(item.rid)
                }
            })
        },
        showSignForm() {
            this.sign = true
        },
        showView(item) {
            this.now = item
            this.view = true
        }
    }
}
</script>
